import * as actions from './actions'
import { pathOr } from 'ramda'

const getRoot = state => state.org
export const getOrgId = state => getRoot(state).orgId
export const getColor = state => getRoot(state).color
export const getUniqueHandle = state => getRoot(state).uniqueHandle
export const getHandle = state => getRoot(state).handle
export const getRole = state => getRoot(state).role
export const getTelephone = state => getRoot(state).telephone
export const getLocale = state => getRoot(state).locale
export const getIcon = state => getRoot(state).iconStyle
export const getWelcomeMessage = state => getRoot(state).welcomeMessage
export const getFinishOnboardingNotification = state => getRoot(state).finishOnboardingNotification

export const getCreateOrgError = state => getRoot(state).createOrgError
export const getOAuthError = state => getRoot(state).oauthError

export const getInstallOption = state => getRoot(state).installOption

const getCreateOrgStatus = state => getRoot(state).createOrgStatus
export const getCreateOrgLoading = state => getCreateOrgStatus(state) === actions.createOrgPending.toString()
export const getCreateOrgFailed = state => getCreateOrgStatus(state) === actions.createOrgFailed.toString()

export const getOrgUsers = state => getRoot(state).orgUsers || []
export const isFirstUser = state => {
  const nonBotUsers = getOrgUsers(state).filter(user => !user.bot)
  return nonBotUsers.length === 0
}

export const getOrgProperties = state => getRoot(state).properties || {}
export const getEmbed = state => getRoot(state).embed || {}

export const getEmbedConfiguration = state => getRoot(state).embed.configuration || {}
export const getEmbedSnippet = state => getRoot(state).embed.snippet

export const getLogoUrl = state => pathOr('', ['embed' , 'configuration', 'theme', 'logoUrl'], getRoot(state))
export const getEmbedId = state => getRoot(state).embed.id



// WEBPACK FOOTER //
// ./src/modules/org/selectors.js